import { ignoreCypress } from '@util/ignore-cypress'
import { segmentTrack, TrackClickProperties } from './track'
import { SegmentTrack } from '@enums/segment'

type SegmentTrackClick = {
  (properties: TrackClickProperties): void
}

const segmentTrackClick: SegmentTrackClick = (clickProperties) => {
  segmentTrack(SegmentTrack.click, clickProperties)
}

export const trackClick = ignoreCypress(segmentTrackClick)
